<template>
  <v-container fluid>
    <v-card flat class="rounded-lg py-2" height="100%">
      <div class="rowDiv contentCenter px-2">
        <div class="rounded-lg pa-1 pageTitle font-weight-black text-h5" style="width: 200px;">使用月結報表</div>
        <div>
          <v-btn depressed  color="success" class="btn_fontSize ml-2" @click="exportFile" :loading="isDownloading">匯出</v-btn>
        </div>
        <v-spacer>
        </v-spacer>
      </div>
      <v-data-table
        class="elevation-1 rounded-lg ml-auto mr-auto mt-2"
        hide-default-header
        hide-default-footer
        :items="usageList"
        :headers="headers"
        :items-per-page="usageList.length"
        :loading="isLoading"
      >
        <!-- <template v-slot:header>
          <thead>
            <tr>
              <th
                class="greyTh"
                v-for="header in headers"
                :key="header.value"
              >
                <div
                  :style="'width:'+header.width+'px'"
                  @click="changeSort(header)"
                  class="sortableThDiv"
                >
                  <div class="sortableThDivText">
                    {{header.text}}
                  </div>
                  <div v-if="header.sortable&&sortItem===header.value">
                    <v-icon v-if="sortOrder">mdi-chevron-down</v-icon>
                    <v-icon v-else>mdi-chevron-up</v-icon>
                  </div>
                </div>
              </th>
            </tr>
          </thead>
        </template> -->
        <template v-slot:item="{ item }">
          <tr :style="item.site_id.length>0?'background-color: #FFFFBB !important;': ''">
            <td 
              v-for="header in headers"
              :key="header.value"
              class="tableTD"
            >
              <div>
                {{item[header.value]}}
              </div>
            </td>
          </tr>
        </template>
        <template v-slot:no-data>
          no data available
        </template>
      </v-data-table>
       <!-- 搜尋 sidebar -->
      <v-navigation-drawer
        app
        clipped
        class="rounded-lg mt-3"
        :width="sidebarWidth"
        height="850"
        permanent
      >
        <div class="rowDiv">
          <v-card-title v-if="sidebarOpen" class="headline font-weight-bold">篩選條件</v-card-title>
          <v-spacer>
          </v-spacer>
          <v-icon
            size = "30"
            style="cursor: pointer;"
            class="mr-5"
            v-if='sidebarOpen'
            @click="sidebarOpen=!sidebarOpen"
          >
            mdi-arrow-expand-left
          </v-icon>
          <v-icon
            size = "30"
            style="cursor: pointer;"
            class="mr-5 mt-5"
            v-else
            @click="sidebarOpen=!sidebarOpen"
          >
            mdi-tune-variant
          </v-icon>
        </div>
        <v-divider></v-divider>
        <div v-if="sidebarOpen">
          <v-card-title style="height:50px;" class="searchTitle">業務用查詢</v-card-title>
          <div style="width:220px; height:30px" class="ml-4">
            <v-checkbox
              v-model="forBusiness"
              label="不查詢測試區"
            ></v-checkbox>
          </div>
          <v-card-title style="height:50px;" class="searchTitle">查詢區間(起)</v-card-title>
          <div style="width:220px; height:30px" class="ml-4">
            <v-menu
              ref="searchStartDateMenu"
              v-model="searchStartDateMenu"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              max-width="290px"
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="searchStartDate"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                  outlined
                  class="rounded-lg"
                  dense
                  hide-details
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="searchStartDate"
                @input="searchStartDateMenu = false"
                no-title
                scrollable
              >
              </v-date-picker>
            </v-menu>
          </div>
          <v-card-title style="height:50px;" class="searchTitle">查詢區間(迄)</v-card-title>
          <div style="width:220px; height:30px" class="ml-4">
            <v-menu
              ref="searchEndDateMenu"
              v-model="searchEndDateMenu"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              max-width="290px"
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="searchEndDate"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                  outlined
                  class="rounded-lg"
                  dense
                  hide-details
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="searchEndDate"
                @input="searchEndDateMenu = false"
                no-title
                scrollable
              >
              </v-date-picker>
            </v-menu>
          </div>
        </div>
      </v-navigation-drawer>
    </v-card>
  </v-container>
</template>
<script>
// import axios from 'axios'
// import router from '../router'
import Service from '../service/service'
export default {
  name: 'Usage_Month',
  data: () => ({
    headers: [
      { text: '', value: 'site_id', sortable: false },
      { text: '', value: 'site_nm',sortable: false },
      { text: '', value: 'site_mno',sortable: false },
      { text: '', value: 'device_seq',sortable: false },
      { text: '', value: 'device_id',sortable: false },
      { text: '', value: 'device_nm',sortable: false },
      { text: '', value: 'use_count',sortable: false },
      { text: '', value: 'create_dt',sortable: false },
      { text: '', value: 'remove_dt',sortable: false },
      { text: '', value: 'area_nm', sortable: false },
    ],
    rows: 99999999,
    sortItem: 'site_id',
    sortOrder: false,
    total: 0,
    pageCount: 0,
    page: 1,
    rowsList: [10, 20, 30, 40, 50],
    controlPermission: [],
    usageList: [],
    sidebarOpen: true,
    sidebarWidth: 260,
    searchStartDate: '',
    searchEndDate: '',
    searchStartDateMenu: false,
    searchEndDateMenu: false,
    forBusiness: true,
    isLoading: false,
    isDownloading: false,
  }),
  mounted: function () {
    // this.path = this.$router.currentRoute.path
    // const control = this.permissions.find(x => x.path === this.path)
    // this.controlPermission = control ? control.permission : []
    this.setDefultDate()
  },
  watch: {
    page () {
      this.getPageData()
    },
    sidebarOpen () {
      if (this.sidebarOpen) {
        this.sidebarWidth = 260
      } else {
        this.sidebarWidth = 70
      }
    },
    rows () {
      this.page === 1 ? this.getPageData() : this.page = 1
    },
    forBusiness () {
      this.page === 1 ? this.getPageData() : this.page = 1
    },
    searchStartDate () {
      this.page === 1 ? this.getPageData() : this.page = 1
    },
    searchEndDate () {
      this.page === 1 ? this.getPageData() : this.page = 1
    },
  },
  props: {
    user: null,
    permissions: null,
    isMobile: null
  },
  computed: {
    order () {
      if (this.sortOrder) {
        return 'desc'
      } else {
        return 'asc'
      }
    }
  },
  methods: {
    showAlert (type, message) {
      var alert = {
        alertType: null,
        alertMessage: '',
        alertIcon: null
      }
      if (type === 'success') {
        alert.alertType = 'success'
        alert.alertIcon = 'mdi-check-circle'
      } else {
        alert.alertType = 'error'
        alert.alertIcon = 'mdi-alert-circle'
      }
      alert.alertMessage = message
      this.$emit('setAlert', alert)
    },
    changeSort (header) {
      if (!header.sortable) return

      if (header.value === this.sortItem) {
        this.sortOrder = !this.sortOrder
      } else {
        this.sortOrder = true
        this.sortItem = header.value
      }
      this.getPageData()
    },
    setDefultDate () {
      const now = new Date()

      let month = now.getMonth()
      let year = now.getFullYear() - !month

      month ||= 12;

      year = String(year).padStart(4, '0')
      month = String(month).padStart(2, '0')

      let date = new Date(year, month, 0).getDate()
      date = String(date).padStart(2, '0')

      this.searchStartDate = `${year}-${month}-01`
      this.searchEndDate = `${year}-${month}-${date}`
    },
    getPageData() {
      this.isLoading = true
      this.usageList = []
      var searchStartDate = {
        name: 'startDate',
        value: this.searchStartDate,
        displayType: 'thanorequal'
      }
      var searchEndDate = {
        name: 'endDate',
        value: this.searchEndDate,
        displayType: 'lessorequal'
      }
      var forBusiness = {
        name: 'forBusiness',
        value: this.forBusiness,
        displayType: '='
      }
      var wheres = [searchStartDate, searchEndDate, forBusiness]
      var parm = {
        page: this.page,
        rows: this.rows,
        order: this.order,
        sort: this.sortItem,
        wheres: JSON.stringify(wheres),
        url: 'site_info/Get_usage_Month_v3'
      }
      Service.getPageData(parm, true)
        .then((response) => {
          // console.log(response)
          if (response.status !== 200 || !response.data.status) {
            this.showAlert('error', response.data.message)
          } else {
            this.total = response.data.data.length
            this.pageCount = Math.ceil(this.total / this.rows)
            this.usageList = response.data.data
            this.usageList.splice(0,1)
          }
        })
      .finally(() => {
        this.isLoading = false
      })
    },
    exportFile () {
      this.isDownloading = true
      var searchStartDate = {
        name: 'startDate',
        value: this.searchStartDate,
        displayType: 'thanorequal'
      }
      var searchEndDate = {
        name: 'endDate',
        value: this.searchEndDate,
        displayType: 'lessorequal'
      }
      var forBusiness = {
        name: 'forBusiness',
        value: this.forBusiness,
        displayType: '='
      }
      var wheres = [searchStartDate, searchEndDate, forBusiness]
      var parm = {
        wheres: JSON.stringify(wheres),
        url: 'site_info/Get_usage_Report'
      }
      Service.exportFile(parm, 90000)
        .then((response) => {
          // console.log(response)
          if (response.status !== 200) {
            this.showAlert('error', response.data.message)
          } else {
            var filename = this.searchStartDate + '-' + this.searchEndDate + '_使用月結報表.xlsx'
            var downloadURL = ''
            var binaryData = []
            binaryData.push(response.data)
            downloadURL = URL.createObjectURL(new Blob(binaryData, { type: 'application/octet-stream' }))
            var link = document.createElement('a')
            link.href = downloadURL
            link.setAttribute('download', filename)
            document.body.appendChild(link)
            link.click()
            link = null
          }
        })
      .finally(() => {
        this.isDownloading = false
      })
    },
  }
}
</script>
